(function () {
    var componentId = 'hostOperationsDashboardRevisedTicketsDetail';
    var app = angular.module('app');

    function controller($state) {
        var vm = this;
        vm.clinicLocation = vm.resolve.clinicLocation;

        vm.close = function () {
            vm.modalInstance.dismiss();
        };
    }

    app.component(componentId, {
        templateUrl: require('/App/host/views/operationsDashboard/revisedTickets/detailModal.html'),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        },
        controller: ['$state', controller],
        controllerAs: 'vm'
    });
})();
